// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__tj3nl","content":"ManualTimeModal_content__3aW5J"};